export const content = [
  // Form.
  'button',
  'input',
  'select',
  'textarea'
]
